var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGaIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.75 4.25C1.75 4.91304 2.01339 5.54893 2.48223 6.01777C2.95107 6.48661 3.58696 6.75 4.25 6.75H8M23 10.5C23.3315 10.5 23.6495 10.3683 23.8839 10.1339C24.1183 9.89946 24.25 9.58152 24.25 9.25V5.5C24.25 5.16848 24.1183 4.85054 23.8839 4.61612C23.6495 4.3817 23.3315 4.25 23 4.25H19.875C19.6809 4.25 19.4896 4.20482 19.316 4.11803C19.1424 4.03125 18.9914 3.90524 18.875 3.75L17.75 2.25C17.6336 2.09476 17.4826 1.96875 17.309 1.88197C17.1354 1.79518 16.9441 1.75 16.75 1.75H14.25C13.9185 1.75 13.6005 1.8817 13.3661 2.11612C13.1317 2.35054 13 2.66848 13 3V9.25C13 9.58152 13.1317 9.89946 13.3661 10.1339C13.6005 10.3683 13.9185 10.5 14.25 10.5H23ZM23 24.25C23.3315 24.25 23.6495 24.1183 23.8839 23.8839C24.1183 23.6495 24.25 23.3315 24.25 23V19.25C24.25 18.9185 24.1183 18.6005 23.8839 18.3661C23.6495 18.1317 23.3315 18 23 18H19.375C19.1463 17.997 18.9228 17.9313 18.7288 17.8101C18.5349 17.6889 18.3779 17.5168 18.275 17.3125L17.75 16.25C17.6524 16.0264 17.4915 15.8362 17.2872 15.703C17.0828 15.5697 16.844 15.4992 16.6 15.5H14.25C13.9185 15.5 13.6005 15.6317 13.3661 15.8661C13.1317 16.1005 13 16.4185 13 16.75V23C13 23.3315 13.1317 23.6495 13.3661 23.8839C13.6005 24.1183 13.9185 24.25 14.25 24.25H23Z",
    stroke: "#243142",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.75 1.75V18C1.75 18.663 2.01339 19.2989 2.48223 19.7678C2.95107 20.2366 3.58696 20.5 4.25 20.5H8",
    stroke: "#243142",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaIcon);
export default __webpack_public_path__ + "static/media/GaIcon.71f7d5f823fb6ce08a32c276f54d79c4.svg";
export { ForwardRef as ReactComponent };